let mainPath = "/suppliers";
let viewFolder = "Supplier";

module.exports = [
    {
        path: mainPath,
        name: 'suppliers',
        component: () => import('../views/'+viewFolder+'/Index.vue'),
    },
    {
        path: mainPath+'/view/:id',
        name: 'supplier',
        component: () => import('../views/'+viewFolder+'/View.vue'),
    },
    {
        path: mainPath+'/create',
        name: 'Create Supplier',
        component: () => import('../views/'+viewFolder+'/Create.vue'),
    }
]